/**
 * @author 133987
 */
var ssg = ssg || {};
ssg.View = ssg.View || {};
ssg.Event = ssg.Event || {};

ssg.View.infiniteMenu = function( htOptions ) {
    $.extend( this, htOptions || {} );
    this.init( );
};

ssg.View.infiniteMenu.prototype = $.extend({
    nCursor : 0,
    sMenuSelector: '#_mcom_nav',
    sActiveClass: 'on',
    sFinishClass: 'end',
    htScroll: {
        nHeight: 45,
        bUseHScroll: true,
        bUseVScroll: false,
        bUseScrollbar: false,
        bUseMomentum: false,
        //bUseMomentum: true,
        bUseBounce: true,
        bUseTranslate: true,
        //bUseCss3d: true,
        bUseCss3d: oSupport.bUseCss3d,
        bActivateOnload: true,
        nFlickThreshold: 30,
        nItemPerPage: 5,
        nDuration: 300,
        bUseHighlight: false
        //sClassName: "item"
    },
    _aPanel : null,
    _aItem : [],
    _nViewWidth: 0,
    _oTouch : null,
    _oScroll : null,
    _elPrevBtn: '<a href="#" class="btn_prev" aria-hidden="true"><span class="sp_com_v2">이전</span></a>',
    _elNextBtn: '<a href="#" class="btn_next" aria-hidden="true"><span class="sp_com_v2">이후</span></a>',
    init : function(){
        this._assignElements();
        this._initVars();
        this._createMenu();
        this._assignComponents();
        this._attachEventHandlers();
        this._fixMenuWidth();
        this._addA11YToMenu();
        this.resize();
        this._finish();
    },
    _assignElements : function(){
        this._welMenus = $(this.sMenuSelector);
        this._welMenuScroll = this._welMenus.children('.mcom_nav');
        this._welMenuItems = this._welMenus.find('ul');
        this._welMenuItem = this._welMenuScroll.find('li');
    },
    _initVars: function(){
        this.nCursor = this.nCursor || this.getActiveMenuIndex();
    },
    _assignComponents: function(){
        this._oScrollMenus = new jindo.m.Scroll( this._welMenus.get(0), this.htScroll );
        //this._oTouchMenus = new jindo.m.Touch( this._welMenus.get(0) );
        //this._oTouchMenus = new jindo.m.Touch( this._welMenuScroll.get(0) );
    },
    _attachEventHandlers: function(){
        this._oScrollMenus.attach("afterScroll", $.proxy(this._onAfterScroll, this));
        //this._oTouchMenus.attach("tap", $.proxy(this._onTap, this));
        this._welMenus.on('click', 'li a', $.proxy(this._onClickMenuItem, this));

        jindo.m.bindRotate($.proxy(this._onRotate, this));
        $(window).on("pageshow", $.proxy(this._onPageShow, this));
    },
    _onAfterScroll: function( we ) {
        var nPos = -this._oScrollMenus.getCurrentPos( ).nLeft,
            nPanelIndex = this._getPanelIndex( );
        if( nPanelIndex != 1 ) {
            for( var i = 0, nLen = this._aItem[ nPanelIndex ].length, v; i < nLen; i++ ) {
                v = this._aItem[nPanelIndex][i];
                //console.log("paneIndex: " , nPanelIndex, ", i: ", i, "v[pos] : ", this._aItem[nPanelIndex][i].pos, "nPos : ", nPos);
                if( nPos < v.pos ) {
                    this._oScrollMenus.scrollTo( this._aItem[1][i].pos - ( this._aItem[nPanelIndex][i].pos - nPos ), 0, 0 );
                    break;
                }
            }
        }
    },
    _onClickMenuItem: function(e){
        e.preventDefault();

        var welTarget = $(e.currentTarget),
            welTargetList = welTarget.parents('li'),
            nIndex = parseInt(welTargetList.attr( "index" ), 10);

        if(!welTargetList.hasClass( this.sActiveClass )){
            this.getElements(this.nCursor).removeClass(this.sActiveClass);
            this.getElements(nIndex).addClass(this.sActiveClass);
            this.nCursor = nIndex;
        }

        this.select( nIndex );
        this._changeLocation(welTarget);
    },
    /*_onTap: function( we ) {
        var welTarget = $(we.element),
            welTargetList = welTarget.parents('li'),
            nIndex = parseInt(welTargetList.attr( "index" ), 10);

        if(!welTarget.parent().hasClass( this.sActiveClass )){
            this.getElements(this.nCursor).removeClass(this.sActiveClass);
            this.getElements(nIndex).addClass(this.sActiveClass);
            this.nCursor = nIndex;
        }

        this.select( nIndex );
        this._changeLocation(welTarget);
    },*/
    _onClickPrevBtn: function(e){
        e.preventDefault();
        this.movePrev();
    },
    _onClickNextBtn: function(e){
        e.preventDefault();
        this.moveNext();
    },
    _onPageShow: function(e){
        var welTarget = null,
            nIndex = null;

        if ( e.originalEvent && e.originalEvent.persisted) {
            welTarget = this._welMenuItem.filter(function(){return $(this).find('a').prop('href') === window.location.href;});

            if(welTarget.length){
                nIndex = parseInt(welTarget.eq(0).attr( "index" ), 10);
                this._activeMenuItem(nIndex);
                this.select( nIndex );
            }
        }
    },
    _createMenu: function(){
        this._welMenuItem
            .css( "float", "left" )
            .each(function(nIndex){
                $(this).attr( "index", nIndex );
            });

        this._cloneAddMenu();
        this._cloneAddMenu();
        this._appendDirection();
        this._welMenuItems = this._welMenus.find('ul');
        this._welMenuItem = this._welMenus.find('li');
    },
    _cloneAddMenu: function(){
        this._welMenuItem.parent().clone( true ).appendTo(this._welMenuScroll);
    },
    _appendDirection: function(){
        $(this._elPrevBtn)
            .on('click', $.proxy(this._onClickPrevBtn, this))
            .appendTo(this._welMenus);

        $(this._elNextBtn)
            .on('click', $.proxy(this._onClickNextBtn, this))
            .appendTo(this._welMenus);
    },
    //change width content type number or sign
    _fixMenuWidth: function(){
        this._welMenuItems.children().each(function(){
            $(this).width($(this).width());
        });
    },
    _addA11YToMenu: function(){
        this._welMenuItems.first().attr('aria-hidden', 'true');
        this._welMenuItems.last().attr('aria-hidden', 'true');
    },
    //get menu width and panel width
    _calcMenuSize: function( ) {
        var nMenuWidth = 0,
            aWidth = [ ];

        this._welMenuItems.eq(0).children().each(function(){
            aWidth.push( $(this).width( ) );
            nMenuWidth += aWidth[ aWidth.length - 1 ];
        });

        return {
            'nMenuWidth': nMenuWidth,
            'aWidth': aWidth
        };
    },
    _activeMenuItem: function(nIndex){
        this.getElements(nIndex)
            .addClass(this.sActiveClass).siblings()
            .removeClass(this.sActiveClass);
    },
    _select: function( ht, nDuration ) {
        if( ht && ht.pos != -this._oScrollMenus.getCurrentPos( ).nLeft ) {
            this._oScrollMenus.scrollTo( ht.pos, 0, nDuration );
            this.nCursor = ht.index;
            this.emit("select", {'nIndex': this.nCursor});
            //this.emit("select", {'nIndex': this.nCursor, 'sHref': this._getSelectLink()});
        }
    },
    _getPanelIndex: function( ) {
        var nPos = -this._oScrollMenus.getCurrentPos( ).nLeft,
            nIndex = 0;

        if( this._aItem[1][0].pos <= nPos && this._aItem[2][0].pos > nPos ) {
            nIndex = 1;
        } else if( this._aItem[2][0].pos <= nPos ) {
            nIndex = 2;
        }
        //console.debug(nPos, "(", nIndex, ")");
        return nIndex;
    },
    _getSelectLink :function(){
        return this._welMenuItems.eq(0).children().eq(this.nCursor).find('a').attr('href');
    },
    _getItemCount : function() {
        return this._aItem[0].length;
    },
    _changeLocation: function(welTarget){
        var welTarget = welTarget.closest('a');

        if(welTarget.attr('href') !== '#'){
            window.location.href = welTarget.attr('href');
        }
    },
    _onRotate: function(){
        this.resize();
    },
    _finish: function(){
        if(this._welMenus.length){
           this._welMenus.addClass(this.sFinishClass);
        }
    },
    movePrev: function(){
        if(this.isMoving()) {
            return;
        }

        var nPrev = this.nCursor - 1, ht;
        var nPanelIndex = this._getPanelIndex();

        if(nPrev < 0 ) {
            nPrev = this._getItemCount()-1;
            ht = this._aItem[nPanelIndex-1][nPrev];
        } else {
            ht = this._aItem[nPanelIndex][nPrev];
        }

        this._select(ht, this.nDuration);
        this._activeMenuItem(ht.index);
    },
    moveNext: function(){
        if(this.isMoving()) {
            return;
        }

        var nNext = this.nCursor + 1, ht;
        var nPanelIndex = this._getPanelIndex();

        if(nNext >= this._getItemCount() ) {
            nNext = 0;
            ht = this._aItem[nPanelIndex+1][nNext];
        } else {
            ht = this._aItem[nPanelIndex][nNext];
        }

        this._select(ht, this.nDuration);
        this._activeMenuItem(ht.index);
    },
    isMoving: function( ) {
        return this._oScrollMenus.isMoving( );
    },
    getActiveMenuIndex : function(){
        return this._welMenuItem.filter('.'+this.sActiveClass).index();
    },
    getElements: function( nIndex ) {
        return this._welMenuItems.find( "[index='" + nIndex + "']" );
    },
    select: function( nIndex, nDuration ) {
        this._select( this._aItem[1][ nIndex ], nDuration );
    },
    // resize menu size
    resize: function( ) {
        var oSelf = this,
            htMenuSize = this._calcMenuSize( ),
            nPos = 0,
            aItem = [];

        this._nViewWidth = this._welMenus.width( );
        this._aItem = [ ];
        this._welMenuItems.each(function(nIndex){
            aItem = [];
            $.each( htMenuSize.aWidth, function( sKey, sVal ) {
                aItem.push( {
                    pos: nPos - ( oSelf._nViewWidth / 2 - sVal / 2 ),
                    width: sVal,
                    index: sKey
                } );
                nPos += sVal;
            });

            $(this).css( {
                "width": htMenuSize.nMenuWidth + "px",
                "height": "100%",
                "position": "absolute",
                "left": ( nIndex * htMenuSize.nMenuWidth ) + "px",
                "top": 0
            } );

            oSelf._aItem.push( aItem );
        });

        this._welMenuScroll.width( htMenuSize.nMenuWidth * 3 );
        this._oScrollMenus.refresh( true );
        this.select( this.nCursor );
    }
}, ssg.Event.emitter);

$(function(){
    //problem: add on class original width changing
    if($("#_mcom_nav").length){
        var oSsgViewInfiniteMenu = new ssg.View.infiniteMenu();
    }
    /*if($("#nav").length){
        new ssg.View.infiniteMenu({sMenuSelector: '#nav', sActiveClass: 'nav_lon'})
    }*/
});